module.exports = __webpack_public_path__ + "static/media/doubleDoor.1edcec23.jpg";